import { createContext, useContext } from 'react';
import { IAlert } from 'components/atoms/Alert';
import { IAccountCreateFormValues } from './form';

export interface IAccountContext {
  createAccount: (body: IAccountCreateFormValues, p?: (res: any) => void) => void;
  createMessage: IAlert;
  isCreateLoading: boolean;
  clearCreateErrors: () => void;
}

export const AccountContext = createContext<IAccountContext>({} as IAccountContext);

export const useAccount = (): IAccountContext => useContext(AccountContext);
